export default __webpack_public_path__ + "static/media/add-user.082d0df4.png";